import axios from 'axios';
// Obtener historial de reservas del usuario autenticado
export const getUserBookings = async () => {
  try {
    const response = await api.get('/reservas/my');
    return response.data;
  } catch (error) {
    console.error('Error al obtener el historial de reservas:', error.response?.data?.message || error.message);
    throw error;
  }
};
// --- Public Rooms API ---
export const crearPublicRoom = async (data) => {
  try {
    const res = await api.post('/reservas/public-rooms', data);
    return res.data;
  } catch (error) {
    console.error('Error al crear sala pública:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const joinPublicRoom = async (data) => {
  try {
    const res = await api.post('/reservas/public-rooms/join', data);
    return res.data;
  } catch (error) {
    console.error('Error al unirse a sala pública:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const getPublicRoom = async (id) => {
  try {
    const res = await api.get(`/reservas/public-rooms/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error al obtener sala pública:', error.response?.data?.message || error.message);
    throw error;
  }
};

export const listPublicRooms = async () => {
  try {
    const res = await api.get('/reservas/public-rooms');
    return res.data;
  } catch (error) {
    console.error('Error al listar salas públicas:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Unirse a una sala pública existente
export const unirseAReservaPublica = async ({ game_id, start_time, players, nombre_cliente, email, telefono }) => {
  try {
    const response = await api.post(`/reservas/games/${game_id}/join-public`, {
      start_time,
      players,
      nombre_cliente,
      email,
      telefono,
    });
    return response.data;
  } catch (error) {
    console.error('Error al unirse a la sala pública:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Obtener reservas públicas para un juego y fecha
export const obtenerReservasPublicas = async (gameId, fecha) => {
  try {
    const res = await api.get(`/reservas/games/${gameId}/public-reservations`, {
      params: { fecha }
    });
    return res.data;
  } catch (err) {
    console.error('Error al obtener reservas públicas:', err);
    return [];
  }
};

// URL de API en producción
const API_URL = 'https://api.lazerzonearena.ca/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,  // Esto asegura que la cookie se envíe y reciba
  credentials: 'include', // IMPORTANTE: Esto envía la cookie
});

export const obtenerJuegos = async () => {
  try {
    const response = await api.get('/juegos');
    return response.data;
  } catch (error) {
    console.error('Error al obtener los juegos:', error);
    throw error;
  }
};

// : Función para registrar usuario social
export const registrarUsuarioSocial = async ({ nombre, correo, provider, uid }) => {
  try {
    const response = await api.post('/auth/register-social', {
      nombre,
      correo,
      provider,
      uid,  // Ahora se incluye el UID
    });
    return response.data;
  } catch (error) {
    console.error('Error al registrar usuario social:', error.response?.data?.message || error.message);
    throw error;
  }
};


// : Función para registrar usuario
export const registrarUsuario = async ({ name, username, email, password }) => {
  try {
    const response = await api.post('/auth/register', {
      name,
      username,
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Error al registrar usuario:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Función para hacer login (en el frontend)
export const signInWithEmailAndPassword = async ({ email, password }) => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error('Error al iniciar sesión:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Función para iniciar sesión con usuario social
export const loginUsuarioSocial = async ({ correo, provider, uid }) => {
  try {
    const response = await api.post('/auth/login-social', {
      correo,
      provider,
      uid,  // Ahora se incluye el UID
    });
    return response.data;
  } catch (error) {
    console.error('Error al iniciar sesión con usuario social:', error.response?.data?.message || error.message);
    throw error;
  }
};


export const obtenerUsuarioAutenticado = async () => {
  try {
    const response = await api.get('/auth/me'); // Asumiendo que tenés esta ruta protegida
    return response.data;
  } catch (error) {
    console.error('No se pudo obtener el usuario autenticado:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Función para cerrar sesión (eliminar la cookie)
export const logoutUsuario = async () => {
  try {
    const response = await api.post('/auth/logout');
    return response.data;  // Esto puede incluir un mensaje confirmando el logout
  } catch (error) {
    console.error('Error al cerrar sesión:', error.response?.data?.message || error.message);
    throw error;
  }
};
export const obtenerHorasReservadas = async (fecha) => {
  try {
    const res = await api.get(`/reservas/horas`, {
      params: { fecha }
    });
    return res.data;
  } catch (err) {
    console.error('Error al obtener horas reservadas:', err);
    return [];
  }
};

export const crearReserva = async (reservaData) => {
  try {
    const response = await api.post('/reservas', reservaData);
    return response.data;
  } catch (error) {
    console.error('Error al crear la reserva:', error.response?.data?.message || error.message);
    throw error;
  }
};
// Obtener configuración del negocio
export const obtenerSettings = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error al obtener settings:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Actualizar nombre de usuario
export const updateUserName = async (userId, name) => {
  try {
    const response = await api.put(`/users/${userId}`, { name });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el nombre:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Cambiar contraseña del usuario autenticado
export const changeUserPassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.put('/auth/change-password', { currentPassword, newPassword });
    return response.data;
  } catch (error) {
    console.error('Error al cambiar la contraseña:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Cambiar nombre del usuario autenticado
export const changeUserName = async (name) => {
  try {
    const response = await api.put('/auth/change-name', { name });
    return response.data;
  } catch (error) {
    console.error('Error al cambiar el nombre:', error.response?.data?.message || error.message);
    throw error;
  }
};